module.exports = __webpack_public_path__ + "img/score-4.c196747f.png";